// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    dashboard: 'Gösterge Paneli',
    notifications: 'Bildirim ayarları',
    portfolios: 'Portföyler',
    reports: 'Raporlar',
    resourcesPage: 'Kaynaklar',
    roles: 'Roller',
    search: 'Ara',
    updateLicense: 'lisans güncelleme',
};
